import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormGrid, Skeleton, Typography } from '../../legacy/components';
import { skipProps, styled } from '../../legacy/utils';
import { DocumentCard } from './DocumentCard';
const Title = ({ title }) => (_jsx(Typography, { marginBottom: "16px", fontSize: "0.5rem", color: "primary", fontWeight: "400", children: title }));
export const DocumentsGroup = ({ loading, label, documents, }) => {
    if (loading) {
        return (_jsxs("div", { children: [label && _jsx(Title, { title: label }), _jsxs(FormGrid, { minWidth: "280px", rowGap: 1, columnGap: 1, children: [_jsx(Skeleton, { variant: "rectangular", width: 280, height: 100 }), _jsx(Skeleton, { variant: "rectangular", width: 280, height: 100 })] })] }));
    }
    if (documents.length === 0) {
        return null;
    }
    return (_jsxs(DocumentsGroupWrapper, { reduceMaxWidth: documents.length === 1, children: [label && _jsx(Title, { title: label }), _jsx(FormGrid, { minWidth: "280px", rowGap: 1, columnGap: 1, children: documents.map((document, i) => (_jsx(DocumentCard, { ...document }, i))) })] }));
};
const DocumentsGroupWrapper = styled('div', {
    shouldForwardProp: skipProps(['reduceMaxWidth']),
})(({ reduceMaxWidth }) => ({
    maxWidth: reduceMaxWidth ? '50%' : '100%',
}));
